import React from 'react'
import Switch from "react-switch";

export const CustomSwitch = ({ onchange, name, ...props }) => {
    return (
        <Switch onColor='#03acff' checkedIcon={false} uncheckedIcon={false} handleDiameter={14} height={20} width={35} onChange={(checked) => onchange({ name: name, value: !!checked ? 1 : 0 })} {...props} />
    )
}
